export default __webpack_public_path__ + "static/source-separation-systems-native-flora-program-089c8e3e0199c4181cb671d5694a7066.jpg";